import updateGhostText from '../actions/updateGhostText';
import getSuggestionText from '../selectors/getSuggestionText';
import getScenarioStore from '../store/getScenarioStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SuggestionKind } from 'owa-search-service';
import { mutator } from 'satcheljs';

export default mutator(updateGhostText, actionMessage => {
    if (!isFeatureEnabled('sea-ghostText')) {
        return;
    }

    const scenarioId = actionMessage.scenarioId;
    const store = getScenarioStore(scenarioId);

    // Clear ghost text if last keystroke was backspace or delete.
    if (store.isLastKeyPressedDeletion) {
        store.ghostText = '';
        return;
    }

    // Clear ghost text if user is navigating suggestions context menu.
    if (store.selectedSuggestionIndex !== -1) {
        store.ghostText = '';
        return;
    }

    // Clear ghost text if there's no search text.
    const searchText = store.searchText;
    if (!searchText) {
        store.ghostText = '';
        return;
    }

    const suggestionsSet = store.currentSuggestions;
    const isSuggestionsSetComplete = suggestionsSet && suggestionsSet.IsComplete;

    /**
     * If suggestions are incomplete, check to see if new search text is still
     * a subset of the existing ghost text. If it's not, clear the ghost text.
     * Otherwise, ghost text is still valid and doesn't need to be updated.
     */
    if (!isSuggestionsSetComplete) {
        if (store.ghostText.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== 0) {
            store.ghostText = '';
            return;
        }
    }

    // Clear ghost text if there's no suggestion.
    const suggestion = suggestionsSet && suggestionsSet.Suggestions[0];
    if (!suggestion) {
        store.ghostText = '';
        return;
    }

    /**
     * To show ghost text, 3S QF must tell us that they have high confidence in
     * the suggestion. Since that's the case, we can only show ghost text for
     * keyword and people suggestions. Otherwise, clear ghost text.
     */
    if (
        !(suggestion.kind === SuggestionKind.Keywords || suggestion.kind === SuggestionKind.People)
    ) {
        store.ghostText = '';
        return;
    }

    // If service doesn't have high confidence in suggestion, clear and return.
    if (!suggestion.Attributes || !suggestion.Attributes.IsAutoCompleteHighConfidence) {
        store.ghostText = '';
        return;
    }

    // Get display text of first suggestion.
    const suggestionText = getSuggestionText(0 /* index */, scenarioId);

    /**
     * Ensure that searchText is a prefix of the suggestionText. If not, clear
     * the ghost text.
     */
    if (suggestionText.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== 0) {
        store.ghostText = '';
        return;
    }

    /**
     * Remove the first part of the suggestion text (the part that matches the
     * user's input) and return the rest.
     */
    store.ghostText = suggestionText.slice(searchText.length);
});
